import React from 'react';
import { H1 } from '../../../components';

import css from './SectionHero.module.css';
import classNames from 'classnames';

const SectionHero = props => {
  const { intl, className, titleClassName } = props;

  return (
    <div className={classNames(css.root, className)}>
      <H1 className={titleClassName}>
        {intl.formatMessage(
          { id: 'HowItWorks.heading' },
          { span: text => <span className={css.marketplaceColoredText}>{text}</span> }
        )}
      </H1>
      <p className={css.description}>{intl.formatMessage({ id: 'HowItWorks.description' })}</p>
    </div>
  );
};

export default SectionHero;
